import { Button } from "components/DesignSystem/Button/Button";
import HeaderFilter from "components/DesignSystem/HeaderFilter/HeaderFilter";
import { DateFilter } from "components/Filters/DateFilter";
import { Funnel } from "components/icons/Funnel";
import { AnimatePresence } from "framer-motion";
import { ReactNode, useEffect, useState } from "react";

export type UpdateFilterType = (name: string, value: string[] | null) => void;

export const ColumnHeaderDateFilter = ({
  isActive,
  updateFilter,
  values,
  handleClearFilter,
  skipMaxEndDate = false,
  topContent,
}: {
  isActive: boolean;
  values: { START_DATE: string; END_DATE: string; SELECT_PERIOD: string };
  updateFilter: (name: string, value: string) => void;
  handleClearFilter: () => void;
  skipMaxEndDate?: boolean;
  topContent?: ReactNode;
}) => {
  const [tempValues, setTempValues] = useState(values);
  const [isOpen, setOpen] = useState(false);

  const updateTempValues = (name: string, value: string) => {
    setTempValues((prev) => ({ ...prev, [name]: value }));
  };

  const applyFilter = () => {
    Object.entries(tempValues).forEach(([key, value]) => {
      updateFilter(key, value);
    });
    setOpen(false);
  };

  useEffect(() => {
    setTempValues(values);
  }, [values]);

  return (
    <HeaderFilter.Root open={isOpen} setOpen={setOpen}>
      <HeaderFilter.Trigger
        icon={<Funnel />}
        isActive={isActive}
        selectedCount={1}
        onClear={handleClearFilter}
        setOpen={setOpen}
      />
      <AnimatePresence>
        <HeaderFilter.Portal {...HeaderFilter.Portal}>
          <HeaderFilter.Content className="t-flex t-justify-between t-flex-col t-w-80 t-h-96">
            <HeaderFilter.Body>
              {topContent}
              <DateFilter
                values={tempValues}
                updateFilter={updateTempValues}
                addMenuPortal
                skipMaxEndDate={skipMaxEndDate}
              />
            </HeaderFilter.Body>
            <HeaderFilter.Footer>
              <Button size="small" onClick={() => setOpen(false)}>
                Clear
              </Button>
              <Button customType="primary" size="small" onClick={applyFilter}>
                Apply
              </Button>
            </HeaderFilter.Footer>
          </HeaderFilter.Content>
        </HeaderFilter.Portal>
      </AnimatePresence>
    </HeaderFilter.Root>
  );
};
